import React, { useState } from 'react'
import useFetch from '../../Services/useFetch'

import { Button } from 'reactstrap';
import { endpoints } from '../../utils/Constants';
import { Input } from 'reactstrap'
import { useEffect } from 'react';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useAlert } from '../../Services/AlertContext';
import IFrameContainer from '../Editors/IFrameContainer';
import SelectSettingNoForm from '../Form/SelectSettingNoForm';
import useFetchSimple from '../../Services/useFetchSimple';

const ManageEmailTemplates = () => {
    const [templateName, setTemplateName] = useState();
    const [template, loadingTemplate, errorTemplate] = useFetch(templateName ? endpoints.getEmailTemplate + '/' + templateName : null);
    const [updated, setUpdated] = useState();
    const [saving, setSaving] = useState();
    const [changed, setChanged] = useState(); 
    const [newItem, setNewItem] = useState(); 
    const [name, setName] = useState(); 
    const fetch = useFetchSimple();
    const alert = useAlert();
    useEffect(() => { loadingTemplate && !saving && setUpdated() }, [saving, loadingTemplate])

    const templateSelected = (item) => {
        setTemplateName(item);
        setNewItem();
    }
    const saveTemplate = async () => {
        const options = { method: 'POST', body: JSON.stringify({ ...template, value: updated, name: newItem ? name : template.name   , }) };
        setSaving(true);
        setChanged(false);
        try {
            var result = await fetch(newItem ? endpoints.newEmailTemplate : endpoints.setEmailTemplate, options);
            const ret = result.body;
            if (ret.success) {
                const m = ret.messages;
                alert({

                    title: <div>
                        <h5>{newItem ? "New Template" : "Updated Template"}</h5>
                        {m && m.length ? m.map(x => <p>{x}</p>) : "Saved OK"}
                    </div>
                    , onDismiss: () => {
                        setSaving(false);
                        setChanged(false);
                        setUpdated(false);
                        setNewItem();

                    }
                });
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>Error saving template</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setSaving(false);

                    }
                });

            }
        }
        catch (e) {
            alert({

                title: "Error", body: JSON.stringify(e)
                , onDismiss: () => {

                    setSaving(false);

                }
            });
        }

    }
    const onchanged = (e) => {
        setUpdated(e);
        
    }
    useEffect(() => {
        if (!changed && updated && template && updated !== template.value) {
            setChanged(true);
        }
    }, [changed, updated, template]);
    return <React.Fragment>
        <Button onClick={() => { setNewItem(true); setName(); }}>New</Button>
        {newItem ? <Input value={name} onChange={(e) => setName(e.target.value)}/>:null}
        <SelectSettingNoForm string endpoint={endpoints.getEmailTemplates} onChange={templateSelected} />
        {errorTemplate?<h6>Error Loading Template</h6>:null}
        {loadingTemplate ? <LoadingAnimation /> : <Input type='textarea' value={updated ? updated : template?.value} onChange={(e) => onchanged(e.target.value)} />}
        {changed || newItem ? <Button onClick={saveTemplate}>Save</Button> : null}
        <IFrameContainer  content={(updated ? updated : template ? template.value : "")}/>
      
    </React.Fragment>

}

export default ManageEmailTemplates;